export enum EmojiCategory {
    REGULAR = 'regular',
    PEOPLE = 'people',
    PROFESSIONAL = 'professional',
    TRANSPORT = 'transport',
    NATURE = 'nature',
    OBJECTS = 'objects',
    FOOD = 'food',
    ACTIVITIES = 'activities',
}

export interface Emoji {
    name: string;
    symbol: string;
    category: EmojiCategory;
}

export interface EmojiCategoryInfo {
    id: EmojiCategory;
    icon: string;
    name: string;
}

const emojiData: Emoji[] = [
    // Regular
    { name: 'smile', symbol: '😊', category: EmojiCategory.REGULAR },
    { name: 'laugh', symbol: '😄', category: EmojiCategory.REGULAR },
    { name: 'wink', symbol: '😉', category: EmojiCategory.REGULAR },
    { name: 'grin', symbol: '😁', category: EmojiCategory.REGULAR },
    { name: 'joy', symbol: '😂', category: EmojiCategory.REGULAR },
    { name: 'sweat_smile', symbol: '😅', category: EmojiCategory.REGULAR },
    { name: 'rolling_eyes', symbol: '🙄', category: EmojiCategory.REGULAR },
    { name: 'neutral', symbol: '😐', category: EmojiCategory.REGULAR },
    { name: 'expressionless', symbol: '😑', category: EmojiCategory.REGULAR },
    { name: 'smirk', symbol: '😏', category: EmojiCategory.REGULAR },
    { name: 'relieved', symbol: '😌', category: EmojiCategory.REGULAR },
    { name: 'sleepy', symbol: '😪', category: EmojiCategory.REGULAR },
    { name: 'sleeping', symbol: '😴', category: EmojiCategory.REGULAR },
    { name: 'dizzy_face', symbol: '😵', category: EmojiCategory.REGULAR },
    { name: 'astonished', symbol: '😲', category: EmojiCategory.REGULAR },
    { name: 'flushed', symbol: '😳', category: EmojiCategory.REGULAR },
    { name: 'scream', symbol: '😱', category: EmojiCategory.REGULAR },
    { name: 'angry', symbol: '😠', category: EmojiCategory.REGULAR },
    { name: 'rage', symbol: '😡', category: EmojiCategory.REGULAR },
    { name: 'cry', symbol: '😢', category: EmojiCategory.REGULAR },
    { name: 'sob', symbol: '😭', category: EmojiCategory.REGULAR },
    { name: 'kiss', symbol: '😘', category: EmojiCategory.REGULAR },
    { name: 'stuck_out_tongue', symbol: '😛', category: EmojiCategory.REGULAR },
    { name: 'yum', symbol: '😋', category: EmojiCategory.REGULAR },
    { name: 'mask', symbol: '😷', category: EmojiCategory.REGULAR },
    { name: 'nerd', symbol: '🤓', category: EmojiCategory.REGULAR },
    { name: 'monocle', symbol: '🧐', category: EmojiCategory.REGULAR },
    { name: 'cowboy', symbol: '🤠', category: EmojiCategory.REGULAR },
    { name: 'party_face', symbol: '🥳', category: EmojiCategory.REGULAR },
    { name: 'pleading', symbol: '🥺', category: EmojiCategory.REGULAR },
    { name: 'star_struck', symbol: '🤩', category: EmojiCategory.REGULAR },
    { name: 'hugging', symbol: '🤗', category: EmojiCategory.REGULAR },
    { name: 'shushing', symbol: '🤫', category: EmojiCategory.REGULAR },
    { name: 'upside_down', symbol: '🙃', category: EmojiCategory.REGULAR },
    { name: 'zany', symbol: '🤪', category: EmojiCategory.REGULAR },
    { name: 'think', symbol: '🤔', category: EmojiCategory.REGULAR },
    { name: 'cool', symbol: '😎', category: EmojiCategory.REGULAR },
    { name: 'nauseated', symbol: '🤢', category: EmojiCategory.REGULAR },
    { name: 'vomiting', symbol: '🤮', category: EmojiCategory.REGULAR },
    { name: 'hot_face', symbol: '🥵', category: EmojiCategory.REGULAR },
    { name: 'cold_face', symbol: '🥶', category: EmojiCategory.REGULAR },
    { name: 'clown', symbol: '🤡', category: EmojiCategory.REGULAR },
    { name: 'heart', symbol: '❤️', category: EmojiCategory.REGULAR },
    { name: 'orange_heart', symbol: '🧡', category: EmojiCategory.REGULAR },
    { name: 'yellow_heart', symbol: '💛', category: EmojiCategory.REGULAR },
    { name: 'purple_heart', symbol: '💜', category: EmojiCategory.REGULAR },
    { name: 'white_heart', symbol: '🤍', category: EmojiCategory.REGULAR },
    { name: 'hundred_points', symbol: '💯', category: EmojiCategory.REGULAR },

    // People
    { name: 'man', symbol: '👨', category: EmojiCategory.PEOPLE },
    { name: 'woman', symbol: '👩', category: EmojiCategory.PEOPLE },
    { name: 'child', symbol: '🧒', category: EmojiCategory.PEOPLE },
    { name: 'boy', symbol: '👦', category: EmojiCategory.PEOPLE },
    { name: 'girl', symbol: '👧', category: EmojiCategory.PEOPLE },
    { name: 'adult', symbol: '🧑', category: EmojiCategory.PEOPLE },
    { name: 'crown', symbol: '👑', category: EmojiCategory.PEOPLE },
    { name: 'thumbsup', symbol: '👍', category: EmojiCategory.PEOPLE },
    { name: 'thumbsdown', symbol: '👎', category: EmojiCategory.PEOPLE },
    { name: 'ok', symbol: '👌', category: EmojiCategory.PEOPLE },
    { name: 'pray', symbol: '🙏', category: EmojiCategory.PEOPLE },
    { name: 'clap', symbol: '👏', category: EmojiCategory.PEOPLE },
    { name: 'wave', symbol: '👋', category: EmojiCategory.PEOPLE },
    { name: 'highfive', symbol: '🙌', category: EmojiCategory.PEOPLE },
    { name: 'fingers_crossed', symbol: '🤞', category: EmojiCategory.PEOPLE },
    { name: 'muscle', symbol: '💪', category: EmojiCategory.PEOPLE },
    { name: 'point', symbol: '👉', category: EmojiCategory.PEOPLE },
    { name: 'victory', symbol: '✌️', category: EmojiCategory.PEOPLE },
    { name: 'old_man', symbol: '👴', category: EmojiCategory.PEOPLE },
    { name: 'old_woman', symbol: '👵', category: EmojiCategory.PEOPLE },
    { name: 'baby', symbol: '👶', category: EmojiCategory.PEOPLE },
    { name: 'person_with_veil', symbol: '👰', category: EmojiCategory.PEOPLE },
    { name: 'person_in_tuxedo', symbol: '🤵', category: EmojiCategory.PEOPLE },
    { name: 'pregnant_woman', symbol: '🤰', category: EmojiCategory.PEOPLE },
    { name: 'breast_feeding', symbol: '🤱', category: EmojiCategory.PEOPLE },
    { name: 'prince', symbol: '🤴', category: EmojiCategory.PEOPLE },
    { name: 'princess', symbol: '👸', category: EmojiCategory.PEOPLE },
    { name: 'superhero', symbol: '🦸', category: EmojiCategory.PEOPLE },
    { name: 'mage', symbol: '🧙', category: EmojiCategory.PEOPLE },
    { name: 'fairy', symbol: '🧚', category: EmojiCategory.PEOPLE },
    { name: 'vampire', symbol: '🧛', category: EmojiCategory.PEOPLE },
    { name: 'merperson', symbol: '🧜', category: EmojiCategory.PEOPLE },
    {
        name: 'person_getting_massage',
        symbol: '💆',
        category: EmojiCategory.PEOPLE,
    },
    {
        name: 'person_getting_haircut',
        symbol: '💇',
        category: EmojiCategory.PEOPLE,
    },
    {
        name: 'man_with_white_cane',
        symbol: '👨‍🦯',
        category: EmojiCategory.PEOPLE,
    },
    {
        name: 'man_in_motorized_wheelchair',
        symbol: '👨‍🦼',
        category: EmojiCategory.PEOPLE,
    },
    {
        name: 'man_in_manual_wheelchair',
        symbol: '👨‍🦽',
        category: EmojiCategory.PEOPLE,
    },
    { name: 'person_running', symbol: '🏃', category: EmojiCategory.PEOPLE },
    { name: 'person_dancing', symbol: '💃', category: EmojiCategory.PEOPLE },
    {
        name: 'person_in_lotus_position',
        symbol: '🧘',
        category: EmojiCategory.PEOPLE,
    },
    {
        name: 'person_taking_bath',
        symbol: '🛀',
        category: EmojiCategory.PEOPLE,
    },
    { name: 'person_in_bed', symbol: '🛌', category: EmojiCategory.PEOPLE },
    {
        name: 'couple_holding_hands',
        symbol: '👫',
        category: EmojiCategory.PEOPLE,
    },
    {
        name: 'two_women_holding_hands',
        symbol: '👭',
        category: EmojiCategory.PEOPLE,
    },
    {
        name: 'two_men_holding_hands',
        symbol: '👬',
        category: EmojiCategory.PEOPLE,
    },
    { name: 'couple_with_heart', symbol: '💑', category: EmojiCategory.PEOPLE },
    { name: 'family', symbol: '👪', category: EmojiCategory.PEOPLE },
    {
        name: 'family_with_children',
        symbol: '👨‍👩‍👧‍👦',
        category: EmojiCategory.PEOPLE,
    },

    // Professional
    { name: 'briefcase', symbol: '💼', category: EmojiCategory.PROFESSIONAL },
    { name: 'necktie', symbol: '👔', category: EmojiCategory.PROFESSIONAL },
    { name: 'chart', symbol: '📊', category: EmojiCategory.PROFESSIONAL },
    { name: 'up', symbol: '📈', category: EmojiCategory.PROFESSIONAL },
    { name: 'memo', symbol: '📝', category: EmojiCategory.PROFESSIONAL },
    { name: 'calendar', symbol: '📅', category: EmojiCategory.PROFESSIONAL },
    { name: 'handshake', symbol: '🤝', category: EmojiCategory.PROFESSIONAL },
    { name: 'money', symbol: '💰', category: EmojiCategory.PROFESSIONAL },
    { name: 'email', symbol: '📧', category: EmojiCategory.PROFESSIONAL },
    { name: 'phone', symbol: '📞', category: EmojiCategory.PROFESSIONAL },
    { name: 'building', symbol: '🏢', category: EmojiCategory.PROFESSIONAL },
    { name: 'people', symbol: '👥', category: EmojiCategory.PROFESSIONAL },
    { name: 'pin', symbol: '📌', category: EmojiCategory.PROFESSIONAL },
    { name: 'target', symbol: '🎯', category: EmojiCategory.PROFESSIONAL },
    { name: 'idea', symbol: '💡', category: EmojiCategory.PROFESSIONAL },
    {
        name: 'presentation',
        symbol: '📊',
        category: EmojiCategory.PROFESSIONAL,
    },
    {
        name: 'man_business',
        symbol: '👨‍💼',
        category: EmojiCategory.PROFESSIONAL,
    },
    { name: 'deadline', symbol: '⏰', category: EmojiCategory.PROFESSIONAL },
    { name: 'contract', symbol: '📄', category: EmojiCategory.PROFESSIONAL },
    { name: 'certificate', symbol: '📜', category: EmojiCategory.PROFESSIONAL },
    { name: 'medal', symbol: '🏅', category: EmojiCategory.PROFESSIONAL },
    { name: 'trophy', symbol: '🏆', category: EmojiCategory.PROFESSIONAL },
    { name: 'check', symbol: '✅', category: EmojiCategory.PROFESSIONAL },
    { name: 'warning', symbol: '⚠️', category: EmojiCategory.PROFESSIONAL },
    { name: 'key', symbol: '🔑', category: EmojiCategory.PROFESSIONAL },
    { name: 'lock', symbol: '🔒', category: EmojiCategory.PROFESSIONAL },
    { name: 'unlock', symbol: '🔓', category: EmojiCategory.PROFESSIONAL },
    {
        name: 'magnifying_glass',
        symbol: '🔍',
        category: EmojiCategory.PROFESSIONAL,
    },
    { name: 'link', symbol: '🔗', category: EmojiCategory.PROFESSIONAL },
    { name: 'clipboard', symbol: '📋', category: EmojiCategory.PROFESSIONAL },
    { name: 'folder', symbol: '📁', category: EmojiCategory.PROFESSIONAL },
    { name: 'open_folder', symbol: '📂', category: EmojiCategory.PROFESSIONAL },
    { name: 'paperclip', symbol: '📎', category: EmojiCategory.PROFESSIONAL },
    {
        name: 'desktop_computer',
        symbol: '🖥️',
        category: EmojiCategory.PROFESSIONAL,
    },
    { name: 'printer', symbol: '🖨️', category: EmojiCategory.PROFESSIONAL },
    { name: 'keyboard', symbol: '⌨️', category: EmojiCategory.PROFESSIONAL },
    { name: 'mouse', symbol: '🖱️', category: EmojiCategory.PROFESSIONAL },
    { name: 'trackball', symbol: '🖲️', category: EmojiCategory.PROFESSIONAL },
    { name: 'minidisc', symbol: '💽', category: EmojiCategory.PROFESSIONAL },
    { name: 'floppy_disk', symbol: '💾', category: EmojiCategory.PROFESSIONAL },
    {
        name: 'optical_disk',
        symbol: '💿',
        category: EmojiCategory.PROFESSIONAL,
    },
    { name: 'dvd', symbol: '📀', category: EmojiCategory.PROFESSIONAL },
    { name: 'abacus', symbol: '🧮', category: EmojiCategory.PROFESSIONAL },
    {
        name: 'balance_scale',
        symbol: '⚖️',
        category: EmojiCategory.PROFESSIONAL,
    },
    { name: 'gear', symbol: '⚙️', category: EmojiCategory.PROFESSIONAL },
    { name: 'compass', symbol: '🧭', category: EmojiCategory.PROFESSIONAL },
    { name: 'magnet', symbol: '🧲', category: EmojiCategory.PROFESSIONAL },
    { name: 'microscope', symbol: '🔬', category: EmojiCategory.PROFESSIONAL },

    // Transport
    { name: 'rocket', symbol: '🚀', category: EmojiCategory.TRANSPORT },
    { name: 'airplane', symbol: '🛩️', category: EmojiCategory.TRANSPORT },
    { name: 'car', symbol: '🚗', category: EmojiCategory.TRANSPORT },
    { name: 'bike', symbol: '🚲', category: EmojiCategory.TRANSPORT },
    { name: 'sailboat', symbol: '⛵', category: EmojiCategory.TRANSPORT },
    { name: 'helicopter', symbol: '🚁', category: EmojiCategory.TRANSPORT },
    { name: 'train', symbol: '🚂', category: EmojiCategory.TRANSPORT },
    { name: 'saucer', symbol: '🛸', category: EmojiCategory.TRANSPORT },
    { name: 'scooter', symbol: '🛵', category: EmojiCategory.TRANSPORT },
    { name: 'speedboat', symbol: '🚤', category: EmojiCategory.TRANSPORT },
    { name: 'bus', symbol: '🚌', category: EmojiCategory.TRANSPORT },
    { name: 'truck', symbol: '🚚', category: EmojiCategory.TRANSPORT },
    { name: 'taxi', symbol: '🚕', category: EmojiCategory.TRANSPORT },
    { name: 'ambulance', symbol: '🚑', category: EmojiCategory.TRANSPORT },
    { name: 'police', symbol: '🚓', category: EmojiCategory.TRANSPORT },
    { name: 'fire_truck', symbol: '🚒', category: EmojiCategory.TRANSPORT },
    { name: 'ship', symbol: '🚢', category: EmojiCategory.TRANSPORT },
    { name: 'metro', symbol: '🚇', category: EmojiCategory.TRANSPORT },
    { name: 'tram', symbol: '🚊', category: EmojiCategory.TRANSPORT },
    { name: 'motorcycle', symbol: '🏍️', category: EmojiCategory.TRANSPORT },
    { name: 'tractor', symbol: '🚜', category: EmojiCategory.TRANSPORT },
    { name: 'cablecar', symbol: '🚡', category: EmojiCategory.TRANSPORT },
    { name: 'ferriswheel', symbol: '🎡', category: EmojiCategory.TRANSPORT },
    { name: 'rollercoaster', symbol: '🎢', category: EmojiCategory.TRANSPORT },
    { name: 'cruise', symbol: '🛳️', category: EmojiCategory.TRANSPORT },
    { name: 'satellite', symbol: '🛰️', category: EmojiCategory.TRANSPORT },
    { name: 'seat', symbol: '💺', category: EmojiCategory.TRANSPORT },
    { name: 'luggage', symbol: '🧳', category: EmojiCategory.TRANSPORT },
    { name: 'passport', symbol: '🛂', category: EmojiCategory.TRANSPORT },
    { name: 'customs', symbol: '🛃', category: EmojiCategory.TRANSPORT },
    { name: 'baggage', symbol: '🛄', category: EmojiCategory.TRANSPORT },
    { name: 'left_luggage', symbol: '🛅', category: EmojiCategory.TRANSPORT },
    {
        name: 'airplane_departure',
        symbol: '🛫',
        category: EmojiCategory.TRANSPORT,
    },
    {
        name: 'airplane_arrival',
        symbol: '🛬',
        category: EmojiCategory.TRANSPORT,
    },
    { name: 'small_airplane', symbol: '🛩️', category: EmojiCategory.TRANSPORT },
    {
        name: 'suspension_railway',
        symbol: '🚟',
        category: EmojiCategory.TRANSPORT,
    },
    {
        name: 'mountain_cableway',
        symbol: '🚠',
        category: EmojiCategory.TRANSPORT,
    },
    { name: 'aerial_tramway', symbol: '🚡', category: EmojiCategory.TRANSPORT },
    { name: 'flying_saucer', symbol: '🛸', category: EmojiCategory.TRANSPORT },
    { name: 'bellhop_bell', symbol: '🛎️', category: EmojiCategory.TRANSPORT },
    { name: 'hourglass_done', symbol: '⌛', category: EmojiCategory.TRANSPORT },
    {
        name: 'hourglass_not_done',
        symbol: '⏳',
        category: EmojiCategory.TRANSPORT,
    },
    { name: 'watch', symbol: '⌚', category: EmojiCategory.TRANSPORT },
    { name: 'alarm_clock', symbol: '⏰', category: EmojiCategory.TRANSPORT },
    { name: 'stopwatch', symbol: '⏱️', category: EmojiCategory.TRANSPORT },
    { name: 'timer_clock', symbol: '⏲️', category: EmojiCategory.TRANSPORT },
    {
        name: 'mantelpiece_clock',
        symbol: '🕰️',
        category: EmojiCategory.TRANSPORT,
    },
    { name: 'motor_scooter', symbol: '🛵', category: EmojiCategory.TRANSPORT },

    // Nature
    { name: 'tree', symbol: '🌳', category: EmojiCategory.NATURE },
    { name: 'flower', symbol: '🌺', category: EmojiCategory.NATURE },
    { name: 'wave', symbol: '🌊', category: EmojiCategory.NATURE },
    { name: 'mountain', symbol: '🏔️', category: EmojiCategory.NATURE },
    { name: 'volcano', symbol: '🌋', category: EmojiCategory.NATURE },
    { name: 'earth', symbol: '🌍', category: EmojiCategory.NATURE },
    { name: 'thunder', symbol: '⛈️', category: EmojiCategory.NATURE },
    { name: 'wind', symbol: '💨', category: EmojiCategory.NATURE },
    { name: 'leaf', symbol: '🍃', category: EmojiCategory.NATURE },
    { name: 'palm', symbol: '🌴', category: EmojiCategory.NATURE },
    { name: 'cactus', symbol: '🌵', category: EmojiCategory.NATURE },
    { name: 'rose', symbol: '🌹', category: EmojiCategory.NATURE },
    { name: 'tulip', symbol: '🌷', category: EmojiCategory.NATURE },
    { name: 'cherry', symbol: '🌸', category: EmojiCategory.NATURE },
    { name: 'maple', symbol: '🍁', category: EmojiCategory.NATURE },
    { name: 'fourleaf', symbol: '🍀', category: EmojiCategory.NATURE },
    { name: 'mushroom', symbol: '🍄', category: EmojiCategory.NATURE },
    { name: 'seed', symbol: '🌱', category: EmojiCategory.NATURE },
    { name: 'blossom', symbol: '🌼', category: EmojiCategory.NATURE },
    { name: 'hibiscus', symbol: '🌺', category: EmojiCategory.NATURE },
    { name: 'sunflower', symbol: '🌻', category: EmojiCategory.NATURE },
    { name: 'bouquet', symbol: '💐', category: EmojiCategory.NATURE },
    { name: 'fallen_leaf', symbol: '🍂', category: EmojiCategory.NATURE },
    { name: 'herb', symbol: '🌿', category: EmojiCategory.NATURE },
    { name: 'shamrock', symbol: '☘️', category: EmojiCategory.NATURE },
    { name: 'evergreen', symbol: '🌲', category: EmojiCategory.NATURE },
    { name: 'deciduous', symbol: '🌳', category: EmojiCategory.NATURE },
    { name: 'sparkles', symbol: '✨', category: EmojiCategory.NATURE },
    { name: 'rainbow', symbol: '🌈', category: EmojiCategory.NATURE },
    { name: 'star', symbol: '⭐', category: EmojiCategory.NATURE },
    { name: 'moon', symbol: '🌙', category: EmojiCategory.NATURE },
    { name: 'sun', symbol: '☀️', category: EmojiCategory.NATURE },
    { name: 'cloud', symbol: '☁️', category: EmojiCategory.NATURE },
    { name: 'rain', symbol: '🌧️', category: EmojiCategory.NATURE },
    { name: 'snow', symbol: '❄️', category: EmojiCategory.NATURE },
    { name: 'fire', symbol: '🔥', category: EmojiCategory.NATURE },
    { name: 'droplet', symbol: '💧', category: EmojiCategory.NATURE },
    { name: 'water_wave', symbol: '🌊', category: EmojiCategory.NATURE },
    { name: 'jack_o_lantern', symbol: '🎃', category: EmojiCategory.NATURE },
    { name: 'christmas_tree', symbol: '🎄', category: EmojiCategory.NATURE },
    { name: 'fireworks', symbol: '🎆', category: EmojiCategory.NATURE },
    { name: 'sparkler', symbol: '🎇', category: EmojiCategory.NATURE },
    { name: 'firecracker', symbol: '🧨', category: EmojiCategory.NATURE },
    { name: 'wind_chime', symbol: '🎐', category: EmojiCategory.NATURE },
    {
        name: 'moon_viewing_ceremony',
        symbol: '🎑',
        category: EmojiCategory.NATURE,
    },
    { name: 'red_envelope', symbol: '🧧', category: EmojiCategory.NATURE },
    { name: 'ribbon', symbol: '🎀', category: EmojiCategory.NATURE },
    { name: 'wrapped_gift', symbol: '🎁', category: EmojiCategory.NATURE },

    // Objects
    { name: 'party', symbol: '🎉', category: EmojiCategory.OBJECTS },
    { name: 'confetti', symbol: '🎊', category: EmojiCategory.OBJECTS },
    { name: 'tada', symbol: '🎉', category: EmojiCategory.OBJECTS },
    { name: 'art', symbol: '🎨', category: EmojiCategory.OBJECTS },
    { name: 'theater', symbol: '🎭', category: EmojiCategory.OBJECTS },
    { name: 'circus', symbol: '🎪', category: EmojiCategory.OBJECTS },
    { name: 'game', symbol: '🎲', category: EmojiCategory.OBJECTS },
    { name: 'crystal', symbol: '🔮', category: EmojiCategory.OBJECTS },
    { name: 'gem', symbol: '💎', category: EmojiCategory.OBJECTS },
    { name: 'gift', symbol: '🎁', category: EmojiCategory.OBJECTS },
    { name: 'lightning', symbol: '⚡', category: EmojiCategory.OBJECTS },
    { name: 'gamepad', symbol: '🎮', category: EmojiCategory.OBJECTS },
    { name: 'mobile', symbol: '📱', category: EmojiCategory.OBJECTS },
    { name: 'laptop', symbol: '💻', category: EmojiCategory.OBJECTS },
    { name: 'books', symbol: '📚', category: EmojiCategory.OBJECTS },
    { name: 'alarm', symbol: '⏰', category: EmojiCategory.OBJECTS },
    { name: 'music', symbol: '🎵', category: EmojiCategory.OBJECTS },
    { name: 'musical_notes', symbol: '🎶', category: EmojiCategory.OBJECTS },
    { name: 'musical_score', symbol: '🎼', category: EmojiCategory.OBJECTS },
    { name: 'camera', symbol: '📷', category: EmojiCategory.OBJECTS },
    { name: 'video', symbol: '🎥', category: EmojiCategory.OBJECTS },
    { name: 'microphone', symbol: '🎤', category: EmojiCategory.OBJECTS },
    { name: 'headphones', symbol: '🎧', category: EmojiCategory.OBJECTS },
    { name: 'guitar', symbol: '🎸', category: EmojiCategory.OBJECTS },
    { name: 'piano', symbol: '🎹', category: EmojiCategory.OBJECTS },
    { name: 'trumpet', symbol: '🎺', category: EmojiCategory.OBJECTS },
    { name: 'violin', symbol: '🎻', category: EmojiCategory.OBJECTS },
    { name: 'drum', symbol: '🥁', category: EmojiCategory.OBJECTS },
    { name: 'saxophone', symbol: '🎷', category: EmojiCategory.OBJECTS },
    { name: 'radio', symbol: '📻', category: EmojiCategory.OBJECTS },
    { name: 'television', symbol: '📺', category: EmojiCategory.OBJECTS },
    { name: 'newspaper', symbol: '📰', category: EmojiCategory.OBJECTS },
    { name: 'bookmark', symbol: '🔖', category: EmojiCategory.OBJECTS },
    { name: 'label', symbol: '🏷️', category: EmojiCategory.OBJECTS },
    { name: 'sunglasses', symbol: '🕶️', category: EmojiCategory.OBJECTS },
    { name: 'crown', symbol: '👑', category: EmojiCategory.OBJECTS },
    { name: 'ring', symbol: '💍', category: EmojiCategory.OBJECTS },
    { name: 'gem_stone', symbol: '💎', category: EmojiCategory.OBJECTS },
    { name: 'scissors', symbol: '✂️', category: EmojiCategory.OBJECTS },
    { name: 'pen', symbol: '🖊️', category: EmojiCategory.OBJECTS },
    { name: 'fountain_pen', symbol: '🖋️', category: EmojiCategory.OBJECTS },
    { name: 'paintbrush', symbol: '🖌️', category: EmojiCategory.OBJECTS },
    { name: 'crayon', symbol: '🖍️', category: EmojiCategory.OBJECTS },
    { name: 'memo', symbol: '📝', category: EmojiCategory.OBJECTS },
    { name: 'briefcase', symbol: '💼', category: EmojiCategory.OBJECTS },
    { name: 'file_folder', symbol: '📁', category: EmojiCategory.OBJECTS },
    { name: 'open_file_folder', symbol: '📂', category: EmojiCategory.OBJECTS },
    {
        name: 'card_index_dividers',
        symbol: '🗂️',
        category: EmojiCategory.OBJECTS,
    },

    // Food
    { name: 'pizza', symbol: '🍕', category: EmojiCategory.FOOD },
    { name: 'icecream', symbol: '🍦', category: EmojiCategory.FOOD },
    { name: 'cookie', symbol: '🍪', category: EmojiCategory.FOOD },
    { name: 'avocado', symbol: '🥑', category: EmojiCategory.FOOD },
    { name: 'wine', symbol: '🍷', category: EmojiCategory.FOOD },
    { name: 'beer', symbol: '🍺', category: EmojiCategory.FOOD },
    { name: 'croissant', symbol: '🥐', category: EmojiCategory.FOOD },
    { name: 'sushi', symbol: '🍣', category: EmojiCategory.FOOD },
    { name: 'taco', symbol: '🌮', category: EmojiCategory.FOOD },
    { name: 'hamburger', symbol: '🍔', category: EmojiCategory.FOOD },
    { name: 'fries', symbol: '🍟', category: EmojiCategory.FOOD },
    { name: 'hotdog', symbol: '🌭', category: EmojiCategory.FOOD },
    { name: 'sandwich', symbol: '🥪', category: EmojiCategory.FOOD },
    { name: 'salad', symbol: '🥗', category: EmojiCategory.FOOD },
    { name: 'soup', symbol: '🥣', category: EmojiCategory.FOOD },
    { name: 'spaghetti', symbol: '🍝', category: EmojiCategory.FOOD },
    { name: 'rice', symbol: '🍚', category: EmojiCategory.FOOD },
    { name: 'bread', symbol: '🍞', category: EmojiCategory.FOOD },
    { name: 'cheese', symbol: '🧀', category: EmojiCategory.FOOD },
    { name: 'egg', symbol: '🥚', category: EmojiCategory.FOOD },
    { name: 'bacon', symbol: '🥓', category: EmojiCategory.FOOD },
    { name: 'donut', symbol: '🍩', category: EmojiCategory.FOOD },
    { name: 'tea', symbol: '🍵', category: EmojiCategory.FOOD },
    { name: 'beers', symbol: '🍻', category: EmojiCategory.FOOD },
    { name: 'water', symbol: '💧', category: EmojiCategory.FOOD },
    { name: 'milk', symbol: '🥛', category: EmojiCategory.FOOD },
    { name: 'champagne', symbol: '🍾', category: EmojiCategory.FOOD },
    { name: 'cocktail', symbol: '🍸', category: EmojiCategory.FOOD },
    { name: 'tropical_drink', symbol: '🍹', category: EmojiCategory.FOOD },
    { name: 'clinking_glasses', symbol: '🥂', category: EmojiCategory.FOOD },
    { name: 'tumbler_glass', symbol: '🥃', category: EmojiCategory.FOOD },
    { name: 'cup_with_straw', symbol: '🥤', category: EmojiCategory.FOOD },
    { name: 'ice_cube', symbol: '🧊', category: EmojiCategory.FOOD },
    { name: 'strawberry', symbol: '🍓', category: EmojiCategory.FOOD },
    { name: 'watermelon', symbol: '🍉', category: EmojiCategory.FOOD },
    { name: 'grapes', symbol: '🍇', category: EmojiCategory.FOOD },
    { name: 'melon', symbol: '🍈', category: EmojiCategory.FOOD },
    { name: 'cherries', symbol: '🍒', category: EmojiCategory.FOOD },
    { name: 'peach', symbol: '🍑', category: EmojiCategory.FOOD },
    { name: 'mango', symbol: '🥭', category: EmojiCategory.FOOD },
    { name: 'pineapple', symbol: '🍍', category: EmojiCategory.FOOD },
    { name: 'coconut', symbol: '🥥', category: EmojiCategory.FOOD },
    { name: 'kiwi_fruit', symbol: '🥝', category: EmojiCategory.FOOD },
    { name: 'tomato', symbol: '🍅', category: EmojiCategory.FOOD },
    { name: 'eggplant', symbol: '🍆', category: EmojiCategory.FOOD },
    { name: 'cucumber', symbol: '🥒', category: EmojiCategory.FOOD },
    { name: 'carrot', symbol: '🥕', category: EmojiCategory.FOOD },
    { name: 'corn', symbol: '🌽', category: EmojiCategory.FOOD },

    // Activities
    { name: 'peace', symbol: '☮️', category: EmojiCategory.ACTIVITIES },
    { name: 'soccer', symbol: '⚽', category: EmojiCategory.ACTIVITIES },
    { name: 'basketball', symbol: '🏀', category: EmojiCategory.ACTIVITIES },
    { name: 'tennis', symbol: '🎾', category: EmojiCategory.ACTIVITIES },
    { name: 'golf', symbol: '⛳', category: EmojiCategory.ACTIVITIES },
    { name: 'swimming', symbol: '🏊', category: EmojiCategory.ACTIVITIES },
    { name: 'surfing', symbol: '🏄', category: EmojiCategory.ACTIVITIES },
    { name: 'skiing', symbol: '⛷️', category: EmojiCategory.ACTIVITIES },
    { name: 'snowboarding', symbol: '🏂', category: EmojiCategory.ACTIVITIES },
    { name: 'hiking', symbol: '🥾', category: EmojiCategory.ACTIVITIES },
    { name: 'camping', symbol: '⛺', category: EmojiCategory.ACTIVITIES },
    { name: 'fishing', symbol: '🎣', category: EmojiCategory.ACTIVITIES },
    { name: 'dancing', symbol: '💃', category: EmojiCategory.ACTIVITIES },
    { name: 'singing', symbol: '🎤', category: EmojiCategory.ACTIVITIES },
    { name: 'painting', symbol: '🎨', category: EmojiCategory.ACTIVITIES },
    { name: 'writing', symbol: '✍️', category: EmojiCategory.ACTIVITIES },
    { name: 'reading', symbol: '📖', category: EmojiCategory.ACTIVITIES },
    { name: 'gaming', symbol: '🎮', category: EmojiCategory.ACTIVITIES },
    { name: 'yoga', symbol: '🧘', category: EmojiCategory.ACTIVITIES },
    { name: 'meditation', symbol: '🧘‍♀️', category: EmojiCategory.ACTIVITIES },
    { name: 'running', symbol: '🏃', category: EmojiCategory.ACTIVITIES },
    { name: 'cycling', symbol: '🚴', category: EmojiCategory.ACTIVITIES },
    { name: 'weightlifting', symbol: '🏋️', category: EmojiCategory.ACTIVITIES },
    { name: 'boxing', symbol: '🥊', category: EmojiCategory.ACTIVITIES },
    { name: 'karate', symbol: '🥋', category: EmojiCategory.ACTIVITIES },
    { name: 'archery', symbol: '🏹', category: EmojiCategory.ACTIVITIES },
    { name: 'fencing', symbol: '🤺', category: EmojiCategory.ACTIVITIES },
    { name: 'wrestling', symbol: '🤼', category: EmojiCategory.ACTIVITIES },
    { name: 'rugby', symbol: '🏉', category: EmojiCategory.ACTIVITIES },
    { name: 'volleyball', symbol: '🏐', category: EmojiCategory.ACTIVITIES },
    { name: 'cricket', symbol: '🏏', category: EmojiCategory.ACTIVITIES },
    { name: 'field_hockey', symbol: '🏑', category: EmojiCategory.ACTIVITIES },
    { name: 'ice_hockey', symbol: '🏒', category: EmojiCategory.ACTIVITIES },
    { name: 'ping_pong', symbol: '🏓', category: EmojiCategory.ACTIVITIES },
    { name: 'badminton', symbol: '🏸', category: EmojiCategory.ACTIVITIES },
    { name: 'bowling', symbol: '🎳', category: EmojiCategory.ACTIVITIES },
    { name: 'ice_skate', symbol: '⛸️', category: EmojiCategory.ACTIVITIES },
    { name: 'fishing_pole', symbol: '🎣', category: EmojiCategory.ACTIVITIES },
    {
        name: 'woman_swimming',
        symbol: '🏊‍♀️',
        category: EmojiCategory.ACTIVITIES,
    },
    { name: 'running_shirt', symbol: '🎽', category: EmojiCategory.ACTIVITIES },
    { name: 'skis', symbol: '🎿', category: EmojiCategory.ACTIVITIES },
    { name: 'sled', symbol: '🛷', category: EmojiCategory.ACTIVITIES },
    {
        name: 'circus_activity',
        symbol: '🎪',
        category: EmojiCategory.ACTIVITIES,
    },
    { name: 'bullseye', symbol: '🎯', category: EmojiCategory.ACTIVITIES },
    { name: 'slot_machine', symbol: '🎰', category: EmojiCategory.ACTIVITIES },
    { name: 'balloon', symbol: '🎈', category: EmojiCategory.ACTIVITIES },
    { name: 'pool_8_ball', symbol: '🎱', category: EmojiCategory.ACTIVITIES },
    { name: 'crystal_ball', symbol: '🔮', category: EmojiCategory.ACTIVITIES },
];

export const emojiCategories: EmojiCategoryInfo[] = [
    { id: EmojiCategory.REGULAR, icon: '😊', name: 'Regular' },
    { id: EmojiCategory.PEOPLE, icon: '👏', name: 'People' },
    { id: EmojiCategory.PROFESSIONAL, icon: '💼', name: 'Professional' },
    { id: EmojiCategory.TRANSPORT, icon: '🚗', name: 'Transport' },
    { id: EmojiCategory.NATURE, icon: '🌳', name: 'Nature' },
    { id: EmojiCategory.OBJECTS, icon: '🎨', name: 'Objects' },
    { id: EmojiCategory.FOOD, icon: '🍕', name: 'Food' },
    { id: EmojiCategory.ACTIVITIES, icon: '⚽', name: 'Activities' },
];

// Helper functions
export const getEmojisByCategory = (
    category: EmojiCategory,
): { name: string; emoji: Emoji }[] =>
    emojiData
        .filter((emoji) => emoji.category === category)
        .map((emoji) => ({ name: emoji.name, emoji }));

export const getEmojiByName = (name: string): Emoji | undefined =>
    emojiData.find((emoji) => emoji.name === name);

export const getEmojiBySymbol = (symbol: string): Emoji | undefined =>
    emojiData.find((emoji) => emoji.symbol === symbol);

export const getAllEmojis = (): Emoji[] => [...emojiData];

export default emojiData;
